// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3YBQo","colCheckbox":"styles_colCheckbox__1NxSb"};